export enum TableId {
  IP = 'ip',
  FundingSource = 'funding-source',
  DeliveryMethod = 'delivery-method',
  User = 'user'
}
